import { render, staticRenderFns } from "./COM_Footer_Setting.vue?vue&type=template&id=64f339a1&"
import script from "./COM_Footer_Setting.vue?vue&type=script&lang=js&"
export * from "./COM_Footer_Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports